var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.currentUser !== null && ! _vm.currentUserUmkm)?_c('NavDrawer'):_vm._e(),(_vm.currentUser === null && _vm.showMenuBar !== false)?_c('MenuBar'):_vm._e(),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }